import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.cscvc.online/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const api = {
  // Auth
  login: (data) => apiClient.post('/auth/login', data),
  me: () => apiClient.get('/auth/me'),
  changePassword: (data) => apiClient.put('/auth/change-password', data),

  // Customers
  getCustomers: (params) => apiClient.get('/customers', { params }),
  getCustomer: (id) => apiClient.get(`/customers/${id}`),
  createCustomer: (data) => apiClient.post('/customers', data),
  updateCustomer: (id, data) => apiClient.put(`/customers/${id}`, data),
  deleteCustomer: (id) => apiClient.delete(`/customers/${id}`),
  getRebookEligible: () => apiClient.get('/customers/rebook-eligible'),

  // Bookings
  getBookings: (params) => apiClient.get('/bookings', { params }),
  getBooking: (id) => apiClient.get(`/bookings/${id}`),
  createBooking: (data) => apiClient.post('/bookings', data),
  updateBookingStatus: (id, status, deliveryDate) =>
    apiClient.patch(`/bookings/${id}/status`, { status, deliveryDate }),
  deleteBooking: (id) => apiClient.delete(`/bookings/${id}`),
  getStats: () => apiClient.get('/bookings/stats'),

  // Users
  getUsers: () => apiClient.get('/users'),
  createUser: (data) => apiClient.post('/users', data),
  updateUser: (id, data) => apiClient.put(`/users/${id}`, data),
  deleteUser: (id) => apiClient.delete(`/users/${id}`),

  // Reports & Invoices
  getInvoice: (bookingId) =>
    apiClient.get(`/reports/invoice/${bookingId}`, { responseType: 'blob' }),
  getInvoiceData: (bookingId) =>
    apiClient.get(`/reports/invoice-data/${bookingId}`),
  getMonthlyReport: (month, year) =>
    apiClient.get('/reports/monthly', { params: { month, year }, responseType: 'blob' }),
  getCustomReport: (startDate, endDate) =>
    apiClient.get('/reports/custom', { params: { startDate, endDate }, responseType: 'blob' }),
};
